export default "/images/a056a2fc5fa44f9a82197cd4a6caf82f.avif";